import { cn } from '@rocco/utils/cn';

interface SelectableCardProps {
    title: string;
    subtitle?: string;
    selected?: boolean;
    onClick: () => void;
}

export const SelectableCard = ({
    title,
    subtitle,
    selected,
    onClick,
}: SelectableCardProps) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                'group flex w-full items-center gap-2 rounded-[0.75rem] bg-[#fdfdfd] px-3 py-4 text-left transition-colors hover:bg-white',
                selected && 'ring-2 ring-black',
            )}
        >
            <span className="flex flex-1 flex-col gap-[0.188rem]">
                <span className="text-[0.9rem] leading-[1.1] font-medium tracking-[-0.02em] text-black">
                    {title}
                </span>
                {subtitle && (
                    <span className="text-[0.75rem] leading-[1.1] font-normal tracking-[-0.02em] text-[#858585]">
                        {subtitle}
                    </span>
                )}
            </span>
            <span
                aria-hidden
                className="text-[0.875rem] text-[#161616] transition-transform group-hover:translate-x-0.5"
            >
                →
            </span>
        </button>
    );
};
